import { Injector } from '@angular/core';
import { Store } from '@sama/app-state';
import { assert } from '@sama/js-core';
import { ShapeState2D } from '../../../../cross-team-shared/annotation/shared/state/shape-state';
import {
  Point2D,
  ShapeType,
} from '../../../../team-apis/otterdam/answers/shape-typings';
import { AbstractVectorTranslationHelper } from '../shared/drag-handlers/abstract-vector-translation-helper';

export const supportedExpandContractShapeTypes: ShapeType[] = [
  'rectangle',
  'slider_rectangle',
];

export class RectangleExpandContractHelper extends AbstractVectorTranslationHelper {
  protected method = 'drag_border';
  protected clickedShapeStore?: Store<ShapeState2D>;
  protected lineIndex: number;

  constructor(
    lineIndex: number,
    injector: Injector,
    shapeStore?: Store<ShapeState2D>,
  ) {
    super(injector);
    this.clickedShapeStore = shapeStore;
    this.lineIndex = lineIndex;
  }

  override getCandidateShapeStores() {
    if (this.clickedShapeStore) {
      return [this.clickedShapeStore];
    }

    const shapeStores = super.getCandidateShapeStores();

    assert(
      shapeStores.every((shapeStore) =>
        supportedExpandContractShapeTypes.includes(shapeStore.state().type),
      ),
      'Only rectangles are allowed when using RectangleExpandContractHelper',
    );

    return shapeStores;
  }

  protected override validateDelta(
    points: Point2D[],
    delta: Point2D,
    pointIndexes: number[],
  ) {
    // fix me if you change this code
    // eslint-disable-next-line no-param-reassign -- fix me!
    delta = super.validateDelta(points, delta, pointIndexes);
    delta[this.lineIndex % 2] = 0;
    return delta;
  }

  protected getMovableSubpointIndexes() {
    return [this.lineIndex, (this.lineIndex + 1) % 4];
  }
}
